<template>
  <h1 class="h4 u-margin-bottom-small u-margin-top u-padding-bottom-small" data-cy="unit-search-heading" v-if="resultLabel">
    <span>{{ resultLabel }}</span>
  </h1>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'UnitsHeader',
  props: {
    unit: { type: Boolean, default: false },
    complex: { type: Boolean, default: false },
    rentalOutside: { type: Boolean, default: false },
  },
  computed: Object.assign(mapGetters(['units']), {
    resultLabel() {
      let label = null

      if (this.rentalOutside) {
        return `${this.units.objectsOutsideDistanceCount} ${this.units.objectsOutsideDistanceCount === 1
          ? this.$label('rentalPropertyOutside')
          : this.$label('rentalPropertiesOutside')
          }`
      } else if (this.complex) {
        label = `${this.units?.complexesCount} ${this.units?.complexesCount === 1
          ? this.$label('housingComplex')
          : this.$label('housingComplexes') 
          }`
      } else if (this.unit) {
        if(this.units?.newComplexesCount > 0) {
        label = `${this.units?.objectsCount} ${this.units?.objectsCount === 1
          ? this.$label('rentalProperty')
          : this.$label('rentalProperties')
          }`
        }
      }
      else if (this.units?.newComplexesCount > 0) {
        label = `${this.units?.newComplexesCount} ${this.units?.newComplexesCount === 1
          ? this.$label('newHousingComplex')
          : this.$label('newHousingComplexes')
          }`
      }
      else {
        if(this.units?.newComplexesCount === 0) {
        label = `${this.units?.objectsCount} ${this.units?.objectsCount === 1
          ? this.$label('rentalProperty')
          : this.$label('rentalProperties')
          }`
        }
      }

      return label
    },
  }),
}
</script>
